import { useLang } from "../contexts/LanguageContext";
import { Reveal } from "../components/site/Reveal";

export default function Exhibitions() {
  const { t } = useLang();

  return (
    <div data-testid="exhibitions-page">
      <section className="pt-16 pb-12 md:pt-20 md:pb-16">
        <div className="container-art">
          <Reveal>
            <div className="overline mb-6">{t.exhibitions_page.overline}</div>
            <h1 className="font-heading text-5xl md:text-7xl font-light tracking-tighter leading-[1.02] max-w-4xl text-balance">
              {t.exhibitions_page.title}
            </h1>
            <p className="mt-8 max-w-xl text-base font-light text-foreground/70 leading-relaxed">
              {t.exhibitions_page.lead}
            </p>
          </Reveal>
        </div>
      </section>

      {/* Locations */}
      <section className="py-20 md:py-28 border-t border-border">
        <div className="container-art grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-16">
          <Reveal className="md:col-span-7">
            <div className="aspect-[16/10] overflow-hidden bg-sand">
              <img
                src="https://gonzaga.pl/img/atelier.png"
                alt="Atelier Poznań"
                className="w-full h-full object-cover"
              />
            </div>
            <p className="overline mt-4">{t.exhibitions.atelierAddress}</p>
          </Reveal>

          <div className="md:col-span-5 flex flex-col gap-10 justify-center">
            <Reveal>
              <div className="overline mb-3">{t.exhibitions.hqOverline}</div>
              <h2 className="font-heading text-4xl font-light tracking-tight">
                {t.exhibitions.atelierTitle} — {t.exhibitions.atelierCity}
              </h2>
              <p className="mt-4 font-body text-base font-light text-foreground/75 leading-relaxed">
                {t.exhibitions.atelierDesc}
              </p>
            </Reveal>
            <Reveal delay={0.1}>
              <div className="grid grid-cols-1 gap-8 pt-8 border-t border-border">
                <div>
                  <div className="overline">{t.exhibitions.france}</div>
                  <h3 className="mt-2 font-heading text-2xl font-light">
                    {t.exhibitions.sainteMaxime}
                  </h3>
                  <p className="mt-2 text-sm font-light text-foreground/70 leading-relaxed">
                    {t.exhibitions.sainteMaximeDesc}
                  </p>
                </div>
                <div>
                  <div className="overline">{t.exhibitions.monaco}</div>
                  <h3 className="mt-2 font-heading text-2xl font-light">
                    {t.exhibitions.monteCarlo}
                  </h3>
                  <p className="mt-2 text-sm font-light text-foreground/70 leading-relaxed">
                    {t.exhibitions.monteCarloDesc}
                  </p>
                </div>
              </div>
            </Reveal>
          </div>
        </div>
      </section>

      {/* Timeline */}
      <section className="py-24 md:py-32 bg-sand">
        <div className="container-art">
          <Reveal>
            <div className="overline mb-5">{t.exhibitions_page.timeline_h}</div>
            <h2 className="font-heading text-4xl md:text-5xl font-light tracking-tight mb-16">
              {t.exhibitions_page.timeline_h}
            </h2>
          </Reveal>

          <ol className="divide-y divide-ink/15">
            {t.exhibitions_page.events.map((ev, i) => (
              <Reveal key={ev.y + ev.t} delay={i * 0.06}>
                <li
                  data-testid={`event-${ev.y}`}
                  className="grid grid-cols-1 md:grid-cols-12 gap-6 py-8 md:py-10"
                >
                  <div className="md:col-span-2 font-heading text-3xl md:text-4xl font-light tracking-tight">
                    {ev.y}
                  </div>
                  <div className="md:col-span-7">
                    <h3 className="font-heading text-2xl font-light tracking-tight">
                      {ev.t}
                    </h3>
                    <p className="mt-2 max-w-xl text-base font-light text-foreground/75 leading-relaxed">
                      {ev.d}
                    </p>
                  </div>
                  <div className="md:col-span-3 md:text-right">
                    <span className="overline">
                      {i === 0 ? "Atelier" : i === 1 ? "Monte Carlo" : i === 2 ? "Sainte-Maxime" : "Poznań"}
                    </span>
                  </div>
                </li>
              </Reveal>
            ))}
          </ol>
        </div>
      </section>
    </div>
  );
}
